import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TicketLinkComponent } from './features/ticket-link/ticket-link.component';
import { TicketAssignmentComponent } from './features/ticket-assignment/ticket-assignment.component';
import { ConfirmationComponent } from './features/confirmation/confirmation.component';
import { SyndicatedHeaderComponent } from './shared/components/syndicated-layout/syndicated-header/syndicated-header.component';
import { SyndicatedFooterComponent } from './shared/components/syndicated-layout/syndicated-footer/syndicated-footer.component';
import { ScriptLoaderComponent } from './shared/components/script-loader/script-loader.component';
import { TmsVisualIdValidatorDirective } from './shared/validators/tms-visualId-validator.directive';
import { DuplicatedVisualIdValidatorDirective } from './shared/validators/duplicated-visuaId-validator-directive';
import { DirtyWordsValidatorDirective } from './shared/validators/dirty-words-validator.directive';
import { WindowRef } from './shared/services/window-ref/window-ref.service';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { OnlyLettersPipe } from './shared/pipes/onlyletters.pipe';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from './shared/services/config/config.service';
import { TranslationsService } from './shared/services/translations/translations.service';
import { CarouselComponent } from './shared/components/carousel/carousel.component';
import { PageKeyModule } from '@wdpr/ra-angular-page-key';
import { AnalyticsModule } from '@wdpr/angular-analytics';
import { LocaleHandler } from './shared/libraries/locale-handler/locale-handler';
import { environment } from '../environments/environment';
import { AnalyticsHandler } from './shared/libraries/analytics-handler/analytics-handler';
import { ProductAddonsSRLabelPipe } from './shared/pipes/product-addon-sr-label.pipe';
import { SharedDataService } from './shared/services/shared-data/shared-data.service';
import { RaInjectOneidAuthTokenModule } from '@wdpr/ra-angular-oneid-auth-token-injector';
import { CoreModule } from './shared/core.module';

const APP_PROVIDERS = [
  WindowRef,
  CookieService,
  SharedDataService,
  AnalyticsHandler
];

@NgModule({
  declarations: [
    AppComponent,
    TicketLinkComponent,
    TicketAssignmentComponent,
    SyndicatedHeaderComponent,
    SyndicatedFooterComponent,
    ConfirmationComponent,
    ScriptLoaderComponent,
    TmsVisualIdValidatorDirective,
    DuplicatedVisualIdValidatorDirective,
    TranslatePipe,
    OnlyLettersPipe,
    DirtyWordsValidatorDirective,
    CarouselComponent,
    ProductAddonsSRLabelPipe
  ],
  imports: [
    BrowserModule,
    CoreModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PageKeyModule,
    AnalyticsModule,
    RaInjectOneidAuthTokenModule
  ],
  providers: [
    APP_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => {
        return config.loadConfig()
          .then((result: any) => {
            return result;
          })
          .catch((err) => {
            return err;
          });
      },
      deps: [ConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (translations: TranslationsService) => () => {
          return translations.loadTranslations()
              .then((result: any) => {
                  return result;
              })
              .catch((err) => {
                  return err;
              });
      },
      deps: [TranslationsService],
      multi: true
    },
    {
        provide: 'PAGE_KEY_URL_ENDPOINT',
        useFactory: (localeHandler: LocaleHandler) => `${
          environment.apiConfiguration.basePath }${
          environment.apiConfiguration.paths.pageKeyData }?env=${
          environment.production ? 'pr' : 'lo' }&lang=${
          encodeURIComponent(localeHandler.getCurrentLanguage())}`,
        deps: [LocaleHandler]
    },
    {
        provide: 'PAGE_KEY_TEMPLATE',
        useValue: ['brand', 'env', 'lang']
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
